import { useTranslation } from 'react-i18next'

import Button from '../../../../../Button'

import * as styles from './ReturnButton.module.css'

import ArrowLeft from '../../../../../../icons/outline-arrow-left.svg'

function ReturnButton({ className = styles.ReturnButton, ...restProps }) {
  const { t } = useTranslation()

  return (
    <Button.Text
      {...restProps}
      beforeIconProps={{ Icon: ArrowLeft }}
      className={className}
      text={t('Auth.SignInByPhoneVerifyCodeChangePhoneBtnKey')}
    />
  )
}

export default ReturnButton
